import React from 'react';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';
import OneTimeChargesSection from './oneTimeChargesSection';
import AcpDiscountSection from './acpDiscountSection';
import VfDiscountSection from './vfDiscountSection';
import { isACPEligibile, isVFEligibile, getSession } from '../../../Helpers';

const OneTimeChargesDiscounts = (props) => {
  const { plansReferenceData, isOneTimeCharges, appId } = props;
  const isTgwFlow = getSession('isTGW');

  return (
    <>
      {isOneTimeCharges && !(isTgwFlow && isTgwFlow === 'true') && (
        <>
          <Line type="secondary" surface="light" />
          <OneTimeChargesSection plansReferenceData={plansReferenceData} />
        </>
      )}
      {isACPEligibile() && appId === 'NSE' && (
        <>
          <Line type="secondary" surface="light" />
          <AcpDiscountSection plansReferenceData={plansReferenceData} />
        </>
      )}
      {isVFEligibile() && (
        <>
          <Line type="secondary" surface="light" />
          <VfDiscountSection plansReferenceData={plansReferenceData} />
        </>
      )}
    </>
  );
};

export default OneTimeChargesDiscounts;

OneTimeChargesDiscounts.propTypes = {
  plansReferenceData: PropTypes.object,
  isOneTimeCharges: PropTypes.bool,
  appId: PropTypes.string,
};
